import { Checkbox, Flex, Form, Input, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { PhoneInput } from 'src/components'
import { paths } from 'src/router'

import { EmailInput } from './EmailInput'

const { Text, Link } = Typography

export const RegisterFormItems = () => {
  const { t } = useTranslation()

  return (
    <Flex orientation="vertical" gap={10}>
      <Form.Item
        name="first_name"
        label={t('first_name')}
        style={{ marginBottom: 0 }}
        rules={[{ required: true }]}
      >
        <Input placeholder="Jonathan" autoFocus autoComplete="given-name" />
      </Form.Item>

      <Form.Item
        name="last_name"
        label={t('last_name')}
        style={{ marginBottom: 0 }}
        rules={[{ required: true }]}
      >
        <Input placeholder="Smith" autoComplete="family-name" />
      </Form.Item>

      <EmailInput name="email" label={t('email')} />

      <Form.Item
        name="phone"
        label={t('phone_number')}
        style={{ marginBottom: 0 }}
        getValueFromEvent={(value: string) => (value ? `+${value}` : '')}
        rules={[{ required: true }]}
      >
        <PhoneInput inputStyle={{ height: 28 }} />
      </Form.Item>

      <Form.Item
        name="terms_and_conditions"
        valuePropName="checked"
        style={{ marginBottom: 0 }}
        rules={[{ required: true, message: t('required_field_error') }]}
      >
        <Checkbox>
          <Flex align="center" gap={4}>
            <Text>{t('i_agree')}</Text>
            <Link
              href={paths.termsAndConditions}
              target="_blank"
              rel="noopener noreferrer"
              underline
            >
              {t('terms_and_conditions')}
            </Link>
          </Flex>
        </Checkbox>
      </Form.Item>
    </Flex>
  )
}
